import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { successNotification, errorNotification, warningNotification } from '../../notification';
import { FormFieldDrop, FormFieldGeneric } from '../../formField';
import FormRow from '../../formRow';
import Popup from '../layout';
import * as productService from '../../../services/product';
import { useForms } from '../../../hooks';

const initialForm = {
  Nome: ''
};

const PopUpProductClass = ({ visible, setVisible, reloadProductClasses, isEdit, entity }) => {
  const [form, updateForm, setForm] = useForms(initialForm);

  const createProductClass = async (body) => {
    const response = await productService.createProductClass(body);
    const { data } = response;
    if (response.status === 200) {
      body = {
        ...body,
        Id: data,
        Editavel: true
      };
      successNotification('Classe de produto criada com sucesso!');
      await reloadProductClasses(body);
    } else if (data.MensagemUsuario !== undefined) warningNotification(data.MensagemUsuario);
    else errorNotification('Houve um erro ao tentar atualizar a classe de produto.');
  };

  const editProductClass = async (body) => {
    const response = await productService.updateProductClass(body, body.Id);
    if (response.status === 200) {
      body = {
        Id: body.Id,
        Editavel: true,
        ...body
      };
      successNotification('Classe de produto atualizada com sucesso!');
      await reloadProductClasses(body);
    } else {
      const { data } = response;
      if (data.MensagemUsuario !== undefined) warningNotification(data.MensagemUsuario);
      else errorNotification('Houve um erro ao tentar atualizar uma classe de produto.');
    }
  };

  const excludeProductClass = async () => {
    const response = await productService.excludeProductClass(entity.Id);
    if (response.status === 200) {
      successNotification('Classe de produto excluída com sucesso!');
      await reloadProductClasses(null);
    } else {
      const { data } = response;
      if (data.MensagemUsuario !== undefined) warningNotification(data.MensagemUsuario);
      else errorNotification('Houve um erro ao tentar excluir uma classe de produto.');
    }
  };

  const submitHandle = () => {
    const body = {
      Id: entity?.Id,
      ...form
    };

    return isEdit ? editProductClass(body) : createProductClass(body);
  };

  useEffect(() => {
    setForm(entity || initialForm);
  }, [entity, visible]);

  return (
    <Popup
      visible={visible}
      setVisible={setVisible}
      title="Classe de Produto"
      confirmText="Salvar"
      cancelText="Cancelar"
      haveExclude={isEdit}
      onConfirm={submitHandle}
      onDelete={excludeProductClass}
    >
      <FormRow>
        <FormFieldGeneric
          titleLabel="Nome"
          classNameWrapper="fill-100-field-tooltip"
          name="Nome"
          onChangeValue={updateForm}
          valueInput={form.Nome}
          required
        />
      </FormRow>
    </Popup>
  );
};

PopUpProductClass.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  reloadProductClasses: PropTypes.func.isRequired
};

export default PopUpProductClass;
